import React from 'react';
import LocationTemplate from './LocationTemplate';

const PittsboroPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Pittsboro"
      stateName="North Carolina"
      countyName="Chatham"
      zipCodes={["27312"]}
      latitude={35.7198}
      longitude={-79.1775}
      population={4546}
      historicalFact="Established in 1787, named for William Pitt the Younger, British Prime Minister."
      nearbyTowns={[
        "Chapel Hill, NC",
        "Durham, NC",
        "Cary, NC",
        "Apex, NC",
        "Sanford, NC",
        "Siler City, NC",
        "Goldston, NC",
        "Moncure, NC"
      ]}
    />
  );
};

export default PittsboroPage;